module.exports = false;


//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0